import { Card, Stack } from '@mui/material';

import { Strings } from '@app/constants';
import { UpcomingHolidaysCard } from '@app/components/card';
import { IManagerDashboard } from '../type';
import { ScheduleList } from './schedule-list';

interface Props {
  data?: IManagerDashboard;
}
const ManagerHolidayAndProject = ({ data }: Props) => {
  return (
    <Stack flexDirection={{ sm: 'column', md: 'row' }} mb={3}>
      <Card
        sx={{
          width: { sm: '97%', md: '45%' },
          height: '450px',
          margin: '0 2% 0 2%',
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <UpcomingHolidaysCard
          title={Strings.employeeDashborad.upcomingHolidays}
          holidays={data?.holidays}
        />
      </Card>
      <Card
        sx={{
          width: { sm: '97%', md: '55%' },
          height: { md: '450px' },
          maxHeight: { xs: '450px' },
          margin: { xs: '0 2% 0 2%', sm: '0 2% 0 2%', md: '0 2% 0 0%' },
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <ScheduleList />
      </Card>
    </Stack>
  );
};

export { ManagerHolidayAndProject };
